<template>
  <div
    :class="{ 'products-table--has-bulk-panel': selectedProductIds.length > 0 }"
  >
    <va-card>
      <div class="d-flex flex-wrap mb-3">
        <div class="flex xs12 md3 mr-3">
          <va-input v-model="term" removable label="Поиск">
            <va-icon slot="prepend" name="fa fa-search" />
          </va-input>
        </div>
      </div>
      <va-data-table
        :fields="fields"
        :loading="loading"
        :data="getProduct"
        class="va-table va-table--hoverable va-table--clickable"
        no-data-label="Пусто"
        no-pagination
        @row-clicked="productPreview"
      >
        <template slot="checkbox" slot-scope="props">
          <div @click.stop>
            <va-checkbox
              :value="isProductSelected(props.rowData.id)"
              @input="(val) => setProductSelection(props.rowData.id, val)"
            />
          </div>
        </template>
        <template slot="image" slot-scope="props">
          <template v-if="props.rowData.photos.length !== 0">
            <img
              :src="props.rowData.photos[0].url"
              class="data-table-server-pagination---avatar"
            />
          </template>
        </template>
        <template slot="categories" slot-scope="props">
          <p
            v-for="(category, index) in props.rowData.categories"
            :key="`category[${index}]` + category.slug + index"
          >
            {{ category.name }}
          </p>
        </template>
        <template slot="components" slot-scope="props">
          <p
            v-for="component in props.rowData.components"
            :key="'component' + component.id"
          >
            {{ component.title }}
          </p>
        </template>
        <template slot="price" slot-scope="props">
          <p v-if="props.rowData.price">
            {{ props.rowData.price.current || 0 }} р.
            <span
              v-if="props.rowData.price.old"
              style="
                text-decoration: line-through;
                color: #999;
                margin-left: 10px;
              "
            >
              {{ props.rowData.price.old }} р.
            </span>
          </p>
        </template>
        <template slot="is_available" slot-scope="props">
          <span
            v-if="
              props.rowData.is_available !== undefined &&
              props.rowData.is_available !== null
            "
          >
            {{ props.rowData.is_available ? "В наличии" : "Нет в наличии" }}
          </span>
          <span v-else>—</span>
        </template>
        <template slot="is_hidden" slot-scope="props">
          <span v-if="props.rowData.is_hidden">Скрыт</span>
          <span v-else>—</span>
        </template>
        <template slot="id" slot-scope="props">
          <button
            type="button"
            class="products-table__action-btn"
            title="Просмотр"
            @click.stop="productPreview(props.rowData)"
          >
            <i class="fa fa-eye" aria-hidden="true"></i>
          </button>
          <router-link
            :to="`/admin/products/${props.rowData.slug}/edit`"
            class="products-table__action-link"
            title="Редактировать"
            @click.native.stop
          >
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </router-link>
          <button
            type="button"
            class="products-table__action-btn products-table__action-btn--danger"
            title="Удалить"
            @click.stop="removeProduct(props.rowData.slug)"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
        </template>
      </va-data-table>
      <va-pagination
        v-if="totalPages > 1"
        v-model="currentPage"
        :page-size="perPage"
        :pages="totalPages"
        class="mt-3"
      />
    </va-card>

    <products-bulk-panel
      :selected-count="selectedProductIds.length"
      :category-to-add="bulkCategoryToAdd"
      :bulk-category-options="bulkCategoryOptions"
      :selected-bulk-category-id="selectedBulkCategoryId"
      :bulk-action-loading="bulkActionLoading"
      @update:category-to-add="bulkCategoryToAdd = $event"
      @bulk-add-category="bulkAddCategory"
      @bulk-remove-category="bulkRemoveCategory"
      @bulk-set-available="bulkSetAvailable"
      @bulk-set-hidden="bulkSetHidden"
      @bulk-delete-selected="bulkDeleteSelected"
      @clear-selection="clearSelection"
    />
    <va-modal
      v-model="showProductPreviewModal"
      size="large"
      hide-default-actions
      class="product-modal"
    >
      <preview-product-modal
        :product-info="currProduct"
        @hide="hideProductModal"
      ></preview-product-modal>
    </va-modal>
  </div>
</template>

<script>
import { debounce } from "lodash";
import api from "@/api/axios";
import { mapActions, mapState } from "vuex";
import PreviewProductModal from "./preview-product-modal.vue";
import ProductsBulkPanel from "./products-bulk-panel.vue";
export default {
  components: { PreviewProductModal, ProductsBulkPanel },
  props: {
    producData: {
      type: Object,
      default: () => {},
      require: true,
    },
  },
  data() {
    return {
      selectedProductIds: [],
      bulkActionLoading: false,
      bulkCategoryToAdd: "",
      showProductPreviewModal: false,
      sizes: [],
      perPage: 50,
      loading: false,
      term: "",
      product: {
        name: "",
        description: "",
        sizes: [],
        uploadImg: "",
        colors: [],
        categories: [],
        components: [],
        reasons: [],
        tags: [],
        photos: [],
      },
      tags: [],
      components: [],
      colors: [],
      categories: [],
      reasons: [],
      productSelectCategory: "",
      selectedFile: [],
      imageData: [],
      selectedFile2: [],
      imgUploadLoader: false,
      imgsIdList: [],
      hide: false,
      currProduct: null,
    };
  },
  computed: {
    ...mapState({
      productsbycategory: "product",
      getProductsWithoutCategory: (state) =>
        state.product.productsWithoutCategory,
    }),

    getProduct() {
      return this.productsbycategory?.productsbycategory?.data || [];
    },
    totalPages() {
      const total = this.productsbycategory?.productsbycategory?.total ?? 0;
      return Math.max(1, Math.ceil(total / this.perPage));
    },
    currentPage: {
      get() {
        const p = parseInt(this.$route.query.page, 10);
        return Number.isFinite(p) && p >= 1 ? p : 1;
      },
      set(page) {
        const query = { ...this.$route.query };
        if (Number(page) === 1) {
          delete query.page;
        } else {
          query.page = page;
        }
        this.$router.replace({ query });
      },
    },
    fields() {
      return [
        {
          name: "__slot:checkbox",
          title: "",
          width: "40px",
        },
        {
          name: "__slot:image",
          title: this.$t("tables.product.photo"),
          width: "40px",
        },
        {
          name: "id",
          title: "ID",
          width: "80px",
        },
        {
          name: "name",
          title: this.$t("tables.product.name"),
          width: "auto",
        },
        {
          name: "__slot:categories",
          title: "КАТЕГОРИЯ/ПОВОД",
        },
        {
          name: "__slot:components",
          title: "Компоненты",
        },
        {
          name: "__slot:price",
          title: this.$t("tables.product.price"),
        },
        {
          name: "__slot:is_available",
          title: "Наличие",
        },
        {
          name: "__slot:is_hidden",
          title: "Скрыт",
        },
        {
          name: "__slot:id",
          title: "",
        },
      ];
    },
    bulkCategoryOptions() {
      const categories = this.productsbycategory?.productData?.categories || [];
      return categories.filter((category) => category && category.id != null);
    },
    selectedBulkCategoryId() {
      if (this.bulkCategoryToAdd == null || this.bulkCategoryToAdd === "") {
        return null;
      }
      if (typeof this.bulkCategoryToAdd === "object") {
        const id = this.bulkCategoryToAdd.id;
        return id != null ? Number(id) : null;
      }
      const id = Number(this.bulkCategoryToAdd);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
  },
  watch: {
    "$route.query"() {
      this.loadProductsWithFilters();
    },
    term() {
      this.debouncedSearch();
    },
  },
  created() {
    this._debouncedSearchRun = debounce(() => {
      const query = { ...this.$route.query };
      delete query.page;
      this.$router
        .replace({ query })
        .catch((err) => {
          if (err?.name !== "NavigationDuplicated") console.error(err);
        })
        .then(() => {
          this.loadProductsWithFilters(1);
        });
    }, 400);
  },
  methods: {
    ...mapActions("product", [
      "deleteProduct",
      "getProductsByCategory",
      "getProductsByCategoryWithFilters",
    ]),
    async loadProductsWithFilters(pageFromRoute) {
      const category =
        this.$route.query.category || "all_products_without_category";
      const page =
        pageFromRoute != null
          ? pageFromRoute
          : parseInt(this.$route.query.page, 10) || 1;
      const raw = this.term == null ? "" : String(this.term);
      const query = raw.trim() || undefined;
      await this.getProductsByCategoryWithFilters({
        category,
        page,
        filters: query ? { query } : {},
      });
    },
    debouncedSearch() {
      this._debouncedSearchRun();
    },
    onFilePicked(event) {
      this.selectedFile.push(event.target.files[0]);
      const imgUrl = URL.createObjectURL(event.target.files[0]);
      this.imageData.push({ img_url: imgUrl });
    },
    async onSubmit() {
      const filteredSizes = this.filteredSizes();
      try {
        const data = {
          name: this.product.name,
          description: this.product.description,
          categories: this.product.categories,
          tags: this.product.tags,
          reasons: this.product.reasons,
          colors: this.product.colors,
          sizes: filteredSizes,
          photos: this.imgsIdList,
        };
        await api.post("/admin/products", data);

        this.showMediumModal = false;
      } catch (error) {
        return error;
      }
    },
    filteredSizes() {
      return this.productData.product.sizes
        .filter((e) => e.qty)
        .map((element) => {
          return {
            id: element.id,
            price: element.price,
            qty: element.qty,
          };
        });
    },
    setSize(key, size, e) {
      size[key] = e.target.value;
    },

    removeImg(imgId) {
      this.imageData.splice(imgId, 1);
    },
    async uploadImg() {
      try {
        this.imgUploadLoader = true;
        const formData = new FormData();

        formData.append("file", this.selectedFile[0]);
        const res = await api.post("/upload-file", formData);
        this.imgsIdList.push(res.data.id);
        this.imgUploadLoader = false;
      } catch (error) {
        return error;
      }
    },
    async removeProduct(productSlug) {
      if (confirm("Вы действительно хотите удалить ?")) {
        this.$store.commit("SET_GLOBAL_LOADER", true);
        try {
          const data = {
            product_slug: productSlug,
            product_category: this.$route.query.category,
          };
          await this.deleteProduct(data);
          this.loadProductsWithFilters();
          this.$store.commit("SET_GLOBAL_LOADER", false);
        } catch (error) {
          this.$store.commit("SET_GLOBAL_LOADER", false);
          return error;
        }
      }
    },
    hideProductModal() {
      this.showProductPreviewModal = false;
    },
    productPreview(productInfo) {
      this.currProduct = productInfo;
      this.showProductPreviewModal = true;
    },

    isProductSelected(id) {
      return this.selectedProductIds.includes(id);
    },
    setProductSelection(id, selected) {
      if (selected) {
        if (!this.selectedProductIds.includes(id)) {
          this.selectedProductIds = [...this.selectedProductIds, id];
        }
      } else {
        this.selectedProductIds = this.selectedProductIds.filter(
          (x) => x !== id
        );
      }
    },
    clearSelection() {
      this.selectedProductIds = [];
    },
    async bulkSetAvailable(isAvailable) {
      if (!this.selectedProductIds.length) return;
      this.bulkActionLoading = true;
      try {
        const res = await api.post("/admin/products/bulk-update-is-available", {
          ids: this.selectedProductIds,
          is_available: isAvailable,
        });
        this.loadProductsWithFilters();
        this.clearSelection();
        if (this.$notify) {
          this.$notify({
            type: "success",
            title: "Обновлено",
            message: `Обновлено товаров: ${res.data?.updated ?? 0}`,
          });
        }
      } catch (err) {
        if (this.$notify) {
          this.$notify({
            type: "error",
            title: "Ошибка",
            message:
              err.response?.data?.message ||
              err.message ||
              "Не удалось обновить",
          });
        }
      } finally {
        this.bulkActionLoading = false;
      }
    },
    async bulkSetHidden(isHidden) {
      if (!this.selectedProductIds.length) return;
      this.bulkActionLoading = true;
      try {
        const res = await api.post("/admin/products/bulk-update-is-hidden", {
          ids: this.selectedProductIds,
          is_hidden: isHidden,
        });
        this.loadProductsWithFilters();
        this.clearSelection();
        if (this.$notify) {
          this.$notify({
            type: "success",
            title: "Обновлено",
            message: `Обновлено товаров: ${res.data?.updated ?? 0}`,
          });
        }
      } catch (err) {
        if (this.$notify) {
          this.$notify({
            type: "error",
            title: "Ошибка",
            message:
              err.response?.data?.message ||
              err.message ||
              "Не удалось обновить",
          });
        }
      } finally {
        this.bulkActionLoading = false;
      }
    },
    async bulkDeleteSelected() {
      if (!this.selectedProductIds.length) return;
      if (
        !confirm(
          `Удалить выбранные товары (${this.selectedProductIds.length})? Действие необратимо.`
        )
      ) {
        return;
      }
      this.bulkActionLoading = true;
      try {
        const res = await api.post("/admin/products/bulk-delete", {
          ids: this.selectedProductIds,
        });
        this.loadProductsWithFilters();
        this.clearSelection();
        if (this.$notify) {
          this.$notify({
            type: "success",
            title: "Удалено",
            message: `Удалено товаров: ${res.data?.deleted ?? 0}`,
          });
        }
      } catch (err) {
        if (this.$notify) {
          this.$notify({
            type: "error",
            title: "Ошибка",
            message:
              err.response?.data?.message ||
              err.message ||
              "Не удалось удалить",
          });
        }
      } finally {
        this.bulkActionLoading = false;
      }
    },
    async bulkAddCategory() {
      if (!this.selectedProductIds.length || !this.selectedBulkCategoryId)
        return;
      this.bulkActionLoading = true;
      try {
        const res = await api.post("/admin/products/bulk-add-category", {
          ids: this.selectedProductIds,
          category_id: this.selectedBulkCategoryId,
        });
        this.loadProductsWithFilters();
        this.clearSelection();
        this.bulkCategoryToAdd = "";
        if (this.$notify) {
          this.$notify({
            type: "success",
            title: "Категория добавлена",
            message: `Обновлено товаров: ${res.data?.updated ?? 0}`,
          });
        }
      } catch (err) {
        if (this.$notify) {
          this.$notify({
            type: "error",
            title: "Ошибка",
            message:
              err.response?.data?.message ||
              err.message ||
              "Не удалось добавить категорию",
          });
        }
      } finally {
        this.bulkActionLoading = false;
      }
    },
    async bulkRemoveCategory() {
      if (!this.selectedProductIds.length || !this.selectedBulkCategoryId)
        return;
      this.bulkActionLoading = true;
      try {
        const res = await api.post("/admin/products/bulk-remove-category", {
          ids: this.selectedProductIds,
          category_id: this.selectedBulkCategoryId,
        });
        this.loadProductsWithFilters();
        this.clearSelection();
        this.bulkCategoryToAdd = "";
        if (this.$notify) {
          this.$notify({
            type: "success",
            title: "Категория удалена",
            message: `Обновлено товаров: ${res.data?.updated ?? 0}`,
          });
        }
      } catch (err) {
        if (this.$notify) {
          this.$notify({
            type: "error",
            title: "Ошибка",
            message:
              err.response?.data?.message ||
              err.message ||
              "Не удалось удалить категорию",
          });
        }
      } finally {
        this.bulkActionLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.data-table-server-pagination---avatar {
  width: 40px;
  height: 40px;
}

.product-modal {
  ::v-deep .va-modal__container {
    max-width: 1000px !important;
    width: 1000px !important;
  }
}

.products-table__action-btn,
.products-table__action-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-right: 4px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #6b7785;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.products-table__action-btn:hover,
.products-table__action-link:hover {
  background: #f1f3f5;
  color: #2c3e50;
}

.products-table__action-btn--danger {
  color: #e34d4d;
}

.products-table__action-btn--danger:hover {
  background: #ffecec;
  color: #c62828;
}

.products-table--has-bulk-panel {
  padding-bottom: 172px;
}
</style>
